import {LangKeyType} from '../../../../../../../provider/locale/translation/type';

export enum AddressCommentTemplateIdEnum {
    streetSide = 'streetSide',
    courtyard = 'courtyard',
    landmark = 'landmark',
    insideBuilding = 'insideBuilding',
    buildingEnd = 'buildingEnd',
    entrance = 'entrance',
    territory = 'territory',
    pavilion = 'pavilion',
}

export type AddressCommentTemplateFieldType = {
    // Placeholder name inside the pattern, e.g. {street}.
    name: string;
    // Shown as the input placeholder and as a tag in the template list.
    hintKey: LangKeyType;
};

export type AddressCommentTemplateType = {
    id: AddressCommentTemplateIdEnum;
    patternKey: LangKeyType;
    fieldList: Array<AddressCommentTemplateFieldType>;
};

export enum AddressCommentSegmentKindEnum {
    text = 'text',
    field = 'field',
}

export type AddressCommentSegmentType =
    | {kind: AddressCommentSegmentKindEnum.text; text: string}
    | {kind: AddressCommentSegmentKindEnum.field; field: AddressCommentTemplateFieldType};
